import { SVG_SIZE, SVGType } from '@/lib/constants';
import React from 'react';

interface Cross extends SVGType, React.HTMLAttributes<SVGElement> {
  stroke?: string;
}

export default function Cross({ size, stroke, className }: Cross) {
  return (
    <svg
      className={className}
      style={{
        height: SVG_SIZE[size].height,
        width: SVG_SIZE[size].width,
        transition: '200ms ease all',
      }}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fill="currentColor"
        stroke={stroke}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.29289 3.29289C3.68342 2.90237 4.31658 2.90237 4.70711 3.29289L8 6.58579L11.2929 3.29289C11.6834 2.90237 12.3166 2.90237 12.7071 3.29289C13.0976 3.68342 13.0976 4.31658 12.7071 4.70711L9.41421 8L12.7071 11.2929C13.0976 11.6834 13.0976 12.3166 12.7071 12.7071C12.3166 13.0976 11.6834 13.0976 11.2929 12.7071L8 9.41421L4.70711 12.7071C4.31658 13.0976 3.68342 13.0976 3.29289 12.7071C2.90237 12.3166 2.90237 11.6834 3.29289 11.2929L6.58579 8L3.29289 4.70711C2.90237 4.31658 2.90237 3.68342 3.29289 3.29289Z"
      />
    </svg>
  );
}
